import { DateTimePicker as MuiDateTimePicker, type DateTimePickerProps as MuiDateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { type PickerFieldProps, pickerFieldSlotProps } from '../../../utils/pickerFieldSlotProps';

type Props = WithoutStyleOverrides<Omit<MuiDateTimePickerProps, 'slots'>> & PickerFieldProps;

export function DateTimePicker(props: Props) {
  const { helperText, error, required, size, fullWidth, slotProps, ...dateTimePickerProps } = props;

  return (
    <MuiDateTimePicker
      {...dateTimePickerProps}
      slotProps={{
        ...slotProps,
        textField: pickerFieldSlotProps(slotProps?.textField, { helperText, error, required, size, fullWidth }),
      }}
    />
  );
}

export type { Props as DateTimePickerProps };
